import { useCallback, useState } from 'react'

/**
 * Select commits typed text only on a separator, so a blur commits whatever
 * is still in the box. Hand `searchValue`/`onSearch` to the Select and
 * `commitOnBlur` to its `onBlur`.
 */
export const useTypedTokenCommit = (
  selectedValues: string[],
  commit: (values: string[]) => void,
): {
  typed: string
  setTyped: (text: string) => void
  commitOnBlur: () => void
} => {
  const [typed, setTyped] = useState('')
  const commitOnBlur = useCallback(() => {
    if (typed.trim() === '') return
    commit([...selectedValues, typed])
    setTyped('')
  }, [typed, selectedValues, commit])
  return { typed, setTyped, commitOnBlur }
}
